import { useState } from 'react';
import Card from 'components/card';
import Stepper from 'views/admin/main/users/newUser/components/Stepper';
import StepperControl from 'views/admin/main/users/newUser/components/StepperControl';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import SchoolInformation from './SchoolInformation';
import LocationDetails from './LocationDetails';
import ContactInformation from './ContactInformation';
import Centered from 'layouts/auth/types/Centered';

const Index = ({
  schoolData,
  setSchoolData,
  handleChange,
  handleSubmit,
  setLoading,
  loading,
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [disable, setDisable] = useState(true);

  const steps = [
    { stepNo: 1, name: 'School Information' },
    { stepNo: 2, name: 'Location Details' },
    { stepNo: 3, name: 'Contact Information' },
  ];
  const displayStep = (step) => {
    switch (step.stepNo) {
      case 1:
        return (
          <SchoolInformation
            schoolData={schoolData}
            setSchoolData={setSchoolData}
            handleChange={handleChange}
            setLoading={setLoading}
            setDisable={setDisable}
          />
        );
      case 2:
        return (
          <LocationDetails
            schoolData={schoolData}
            setSchoolData={setSchoolData}
            handleChange={handleChange}
            setLoading={setLoading}
            setDisable={setDisable}
          />
        );
      case 3:
        return (
          <ContactInformation
            schoolData={schoolData}
            setSchoolData={setSchoolData}
            handleChange={handleChange}
            setLoading={setLoading}
            setDisable={setDisable}
          />
        );
      default:
    }
  };

  const handleClick = (direction) => {
    let newStep = currentStep;
    direction === 'next' ? newStep++ : newStep--;
    newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
  };
  return (
    <Centered
      maincard={
        <Card extra=" w-full m-auto max-w-[95%] md:max-w-[70%] h-max mt-32 md:mt-[40px]  mb-auto pb-2.5 pt-8 md:pt-2.5 px-4 md:!p-[40px]">
          <div className="mt-3 h-full w-full">
            <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
            <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
              <div className="-mt-[280px] w-full pb-14 md:-mt-[350px] md:px-[70px]">
                <Stepper
                  // action={setCurrentStep}
                  steps={steps}
                  currentStep={currentStep}
                />
              </div>
              <Card extra={'h-full mx-auto pb-3'}>
                <div className="rounded-[20px] ">
                  <UseContextProvider>
                    {displayStep(steps[currentStep - 1])}
                  </UseContextProvider>
                </div>
                <StepperControl
                  handleClick={handleClick}
                  currentStep={currentStep}
                  steps={steps}
                  loading={loading}
                  disable={disable}
                  handleSubmit={handleSubmit}
                />
              </Card>
            </div>
          </div>
        </Card>
      }
    />
  );
};

export default Index;
